export const MODULO_PARAM = ['FAB_Modulo_Codigo']
